






























import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class EmailPanel extends Vue {
  @Prop({ type: Number }) readonly left!: number
  @Prop({ type: Number }) readonly top!: number

  list = [
    {
      name: 'Wang',
      date: '09/09/2023 15:57',
      title: 'Complete Bill customer data collection',
      des: "Collect customer's phone number, address, common contacts, copies of document",
      color: '#1BBC9C'
    },
    {
      name: 'Bill',
      date: '09/09/2023 15:57',
      title: 'Complete Bill customer data collection',
      des: "Collect customer's phone number, address, common contacts, copies of document",
      color: '#309BFF'
    },
    {
      name: 'Kitty',
      date: '09/09/2023 15:57',
      title: 'Complete Bill customer data collection',
      des: "Collect customer's phone number, address, common contacts, copies of document",
      color: '#FFAD62'
    },
    {
      name: 'Dan',
      date: '09/09/2023 15:57',
      title: 'Complete Bill customer data collection',
      des: "Collect customer's phone number, address, common contacts, copies of document",
      color: '#56DA91'
    },
    {
      name: 'Ann',
      date: '09/09/2023 15:57',
      title: 'Complete Bill customer data collection',
      des: "Collect customer's phone number, address, common contacts, copies of document",
      color: '#FF7A7A'
    }
  ]

  @Emit('hide')
  hide () {}
}
